import { useState, useRef, useEffect } from 'react'

const SEOCopy = ({ seoCopyHtml }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [showMoreBtn, setShowMoreBtn] = useState(false)

  const myRef = useRef(null)
  const getUpdateDimensions = () => {
    if (myRef.current?.offsetHeight < 58) {
      setIsExpanded(true)
      setShowMoreBtn(false)
    } else {
      setIsExpanded(false)
      setShowMoreBtn(true)
    }
  }

  useEffect(() => {
    if (myRef) {
      // @ts-ignore
      new ResizeObserver(getUpdateDimensions).observe(myRef.current)
    }
  }, [myRef])

  return (
    <div className="seo-copy">
        <div id="seo-copy-id" className={isExpanded ? 'seo-copy__show-content' : 'seo-copy__hide-content' }>
            <div id="seo-copy-details" ref={myRef} dangerouslySetInnerHTML={{ __html: seoCopyHtml }} />
        </div>
        { showMoreBtn && <div className='seo-copy__show-more'>
          <button className="seo-copy__show-more-btn" onClick={() => setIsExpanded(!isExpanded)} >{ isExpanded ? 'SHOW LESS' : 'SHOW MORE'}</button>
        </div>}
    </div>
  )
}
export default SEOCopy
